import {createFileRoute} from '@tanstack/react-router';
import {KYCSelectPage} from '../../../../features/settings/pages/KYCSelectPage';

export const Route = createFileRoute('/_protected/home/service/kyc')({
  component: KYCSelectPage,
  staticData: {crumbKey: 'navigation.kyc'},
});
